module.exports = __webpack_public_path__ + "img/presentation02.974228cd.jpg";